module.exports = {
      id: "favorite-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#favorite-usage",
      toString: function () {
        return this.url;
      }
    }